import { render, staticRenderFns } from "./Authenticate.vue?vue&type=template&id=f1d21a02&scoped=true"
import script from "./Authenticate.vue?vue&type=script&lang=js"
export * from "./Authenticate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d21a02",
  null
  
)

export default component.exports